import { Reveal } from "./Reveal";
import LeadForm from "./LeadForm";

export default function RegisterSection({ idPrefix }) {
  return (
    <section id="register" className="bg-[#F3F3FA] px-4 sm:px-8 lg:px-12 py-14 sm:py-20 lg:py-28 scroll-mt-16">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        <Reveal>
          <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.25em] text-[#1B2FD8]">Free Challenge</p>
          <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl text-[#0B0B12] mt-4 leading-[1.02]">
            READY TO GET<br />BACK TO <span className="italic text-[#1B2FD8]">YOU?</span>
          </h2>
          <p className="mt-6 text-[#4A4A66] text-base md:text-lg leading-relaxed max-w-md">
            Spots are free. The commitment is 14 days. Eat. Supplement. Walk. Hydrate. Restorative yoga. Sleep. Recover.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="bg-white rounded-3xl border border-[#E3E3F0] shadow-xl shadow-[#0B0B12]/5 p-5 sm:p-10">
            <LeadForm idPrefix={idPrefix} />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
